import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledThead = styled(View)(({
  theme
}) => ({
  position: 'sticky',
  top: theme.space['0'],
  width: '100%',
  zIndex: 10,
  background: theme.color['fill-surface-default']
}));
const StyledTH = styled(View)(({
  theme
}) => ({
  verticalAlign: 'bottom',
  padding: theme.space['400'],
  borderRight: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`,
  // fontWeight styling only added bc it exists in the control. This reduces the weight of the "included in current plan" and "recommended" badges.
  // This styling should not persist after the experiment. Just delete this line.
  fontWeight: theme.typography['body-100'].fontWeight,
  '&:first-child': {
    paddingLeft: theme.space['0']
  },
  '&:last-child': {
    borderRight: 'none'
  }
}));
const TableHeader = ({
  apiNames,
  headerData
}) => {
  return /*#__PURE__*/_jsx(StyledThead, {
    as: "thead",
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx(StyledTH, {
        as: "th",
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          typography: "heading-500",
          textAlign: "left",
          paddingInlineStart: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.featureTable.tableHeader.features"
          })
        })
      }), apiNames.map(apiName => {
        const headerCellData = headerData[apiName];
        if (!headerCellData) {
          return /*#__PURE__*/_jsx("th", {}, `${apiName}-header-cell`);
        }
        const {
          Content
        } = headerCellData;
        return /*#__PURE__*/_jsx(StyledTH, {
          as: "th",
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            alignItems: "center",
            rowGap: "200",
            children: Content
          })
        }, `${apiName}-header-cell`);
      })]
    })
  });
};
export default TableHeader;